export default __webpack_public_path__ + "static/media/1-5mmb.f3f7b51e.jpg";